import { render, staticRenderFns } from "./createArquivoProtocolo.vue?vue&type=template&id=7c73bf09&scoped=true&"
import script from "./createArquivoProtocolo.vue?vue&type=script&lang=js&"
export * from "./createArquivoProtocolo.vue?vue&type=script&lang=js&"
import style0 from "./createArquivoProtocolo.vue?vue&type=style&index=0&id=7c73bf09&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c73bf09",
  null
  
)

export default component.exports